import Swiper, { Pagination, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const init = (wrapper) => {
  const carousel = wrapper.querySelector('.js-press-carousel-carousel')
  const carouselSlides = carousel.querySelectorAll('.swiper-slide')
  if (carouselSlides.length < 1) return

  const logoList = [...carouselSlides].map(el => ({
    logoImage: el.getAttribute('data-logo-image'),
    logoImageAlt: el.getAttribute('data-logo-image-alt')
  }))

  return new Swiper(carousel.querySelector('.swiper'), {
    modules: [
      Pagination,
      Navigation
    ],
    cssMode: false,
    slidesPerView: 1,
    loop: carouselSlides.length > 1,
    speed: 600,
    pagination: {
      el: carousel.querySelector('.swiper-pagination'),
      clickable: true,
      renderBullet: function (index, className) {
        return `<button type="button" class="press-carousel__logo ${className}">
          <img class="press-carousel__logo-image" src="${logoList[index].logoImage}" alt="${logoList[index].logoImageAlt}" />
        </button>`
      }
    },
    navigation: {
      nextEl: carousel.querySelector('.swiper-button-next'),
      prevEl: carousel.querySelector('.swiper-button-prev')
    },
  })
}

export default () => {
  document.querySelectorAll('.js-press-carousel').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}
